import { IconLink, Text } from '@vtex/admin-ui'
import { useIntl } from 'react-intl'
import type { UTM as UTMType } from 'typings'
import { Tag, TagsListTruncate } from '../../../Tag'
import {
  Rule,
  RuleActions,
  RuleContent,
  RuleDescription,
  RuleIcon,
  RuleStack,
} from '../../RuleStack'
import { RuleDefaultActions } from '../../RuleStack/DefaultActions'
import { messages } from './messages'

type Props = {
  values: UTMType | undefined
  onEdit: () => void
  onRemove: () => void
}

export function UTMView(props: Props) {
  const { values, onEdit, onRemove } = props
  const { formatMessage: i18n } = useIntl()

  if (!values) return

  return (
    <Rule onClick={onEdit}>
      <RuleIcon>
        <IconLink />
      </RuleIcon>

      <RuleDescription>
        <Text variant="body">{i18n(messages.title)}</Text>
      </RuleDescription>

      <RuleContent>
        <RuleStack>
          {Object.entries(values)
            .filter(([_, values]) => Boolean(values.length))
            .map((entryPair) => {
              const [key, values] = entryPair as [keyof UTMType, string[]]

              return (
                <Rule key={key}>
                  <RuleDescription>
                    {i18n(messages.utmDescription[key], {
                      b: (content: React.ReactNode) => (
                        <Text variant="body">{content}</Text>
                      ),
                      count: values.length,
                    })}
                  </RuleDescription>

                  <RuleContent>
                    <TagsListTruncate content={values} lines={5}>
                      {values.map((utm, index) => (
                        <TagsListTruncate.Atom key={index}>
                          <Tag key={index}>{utm}</Tag>
                        </TagsListTruncate.Atom>
                      ))}
                    </TagsListTruncate>
                  </RuleContent>
                </Rule>
              )
            })}
        </RuleStack>
      </RuleContent>

      <RuleActions>
        <RuleDefaultActions onEdit={onEdit} onRemove={onRemove} />
      </RuleActions>
    </Rule>
  )
}
